// components
import { FormInput } from "./FormInput"
import { FormLabel } from "./FormLabel"
import { ResponsiveText } from "@components/Typography"
// helpers
import { cn } from "src/utils/common.helper"

export const InputWithLabel = ({
    label,
    labelElement,
    name,
    rules,
    type,
    icon,
    placeholder,
    control,
    errors,
    customInput,
    containerClassName,
    inputContainerClassName,
    inputClassName,
    isRequired = false,
}) => (
    <div className={cn("flex flex-col gap-2", containerClassName)}>
        <FormLabel name={name} isRequired={isRequired}>
            {labelElement || label}
        </FormLabel>
        {customInput ? (
            <>{customInput}</>
        ) : (
            <>
                <FormInput
                    name={name}
                    rules={rules}
                    type={type}
                    icon={icon}
                    placeholder={placeholder}
                    inputContainerClassName={inputContainerClassName}
                    inputClassName={inputClassName}
                    control={control}
                    errors={errors}
                />
            </>
        )}
        {errors[name]?.message && (
            <ResponsiveText size="xs" variant="error">
                {errors[name]?.message}
            </ResponsiveText>
        )}
    </div>
)
